import styled from 'styled-components'

const StPageLinkContainer = styled.div`
  display: contents;

  > *:hover {
    cursor: pointer;
    transition: background 175ms ease-in-out;
    background-color: ${({ theme }) => theme.Colors.Neutrals.Lighter};
  }
`

export { StPageLinkContainer }
